type ActionPlansUser = {
  rda_access?: boolean
}

export const hasActionPlansAccess = (user?: ActionPlansUser | null) => {
  return user?.rda_access === true
}
